<template>
  <div class="index-container">
    <Header />
    <div class="index-banner">
      <nav-list />
      <div class="banner" v-loading="bloadding">
        <el-carousel height="400px" :initialIndex="bindex">
          <el-carousel-item
            v-for="(item, index) in bannerList"
            :key="index"
            :name="index"
          >
            <img :src="item.fullPicUrl" alt="无图片" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <img src="@/assets/banner.png" alt="" /> -->
      <div class="banner-title">
        <!-- <text class="big-title">数据赋能 智慧城市</text>
        <text class="sm-title"
          >- 全面支撑新型智慧城市 数据赋能提升城市幸福感</text
        > -->
      </div>
      <div class="data-info">
        <div class="info-item">
          <div class="info-item-title">开放数据目录总量</div>
          <div class="sm-title">{{ opencatalog }} <span>个</span></div>
        </div>
        <div class="info-item">
          <div class="info-item-title">数据总量</div>
          <div class="sm-title">{{ datacount }} <span>条</span></div>
        </div>
        <div class="info-item">
          <div class="info-item-title">接口总量</div>
          <div class="sm-title">{{ facecount }}<span>个</span></div>
        </div>
        <div class="info-item">
          <div class="info-item-title">文件下载量</div>
          <div class="sm-title">{{ downcount }}<span>次</span></div>
        </div>
        <div class="info-item">
          <div class="info-item-title">接口调用量</div>
          <div class="sm-title">{{ viewCount }} <span>次</span></div>
        </div>
      </div>
    </div>

    <category-list />
    <app-scenarios />
    <info-list />
    <help-info />
    <Suggest />
  </div>
</template>
<script>
import { title } from "@/config";
// import NavList from "@/components/navlist/index.vue";

import NavList from "@/components/otherNavList/index";
import Header from "@/components/header/index";
import Suggest from "./components/suggest";
import helpInfo from "./components/help-info";
import infoList from "./components/info-list";
import categoryList from "./components/category-list";
import AppScenarios from "./components/app_scenarios.vue";
import gsap from "gsap";
import { getIndexcount, getBanner } from "@/api/index";

export default {
  computed: {
    downcountData: function() {
      return this.downcount;
    },
    opencatalogData: function() {
      return this.opencatalog;
    },
    datacountData: function() {
      return this.datacount;
    },
    viewCountData: function() {
      return this.viewCount;
    },
    facecountData: function() {
      return this.facecount;
    }
  },
  components: {
    Suggest,
    helpInfo,
    infoList,
    categoryList,
    AppScenarios,
    NavList,
    Header
  },
  name: "index",
  data() {
    return {
      bindex: 0,
      bloadding: true,
      downcount: 0,
      opencatalog: 0,
      datacount: 0,
      viewCount: 0,
      facecount: 0,
      searchValue: "",
      title: title,
      acticveNavIndex: 0,
      activeName: "dataCategory",
      navList: [
        { title: "首页" },
        { title: "开放数据" },
        { title: "应用成果" },
        { title: "帮助中心" },
        { title: "接口服务" },
        { title: "地图服务" },
        { title: "政策法规" },
        { title: "开发者中心" },
        { title: "开放指数" }
      ],
      dataCategory: [
        { title: "首页", image: "" },
        { title: "开放数据", image: "" },
        { title: "应用成果", image: "" },
        { title: "帮助中心", image: "" },
        { title: "接口服务", image: "" },
        { title: "地图服务", image: "" },
        { title: "政策法规", image: "" },
        { title: "开发者中心", image: "" },
        { title: "开放指数", image: "" }
      ],
      departmentcategory: [
        { title: "首页" },
        { title: "开放数据" },
        { title: "应用成果" },
        { title: "帮助中心" },
        { title: "接口服务" },
        { title: "地图服务" },
        { title: "政策法规" },
        { title: "开发者中心" },
        { title: "开放指数" }
      ],
      bannerList: [
        {
          fullPicUrl:
            "http://open.huaibeidata.cn:1123/uploads//202109/863dab4d13684041869b07e34998133c.jpeg?stamp=1631350551796"
        }
      ]
    };
  },
  async created() {
    getBanner().then(data => {
      var self = this;
      console.log(this.bindex);
      this.bannerList = data.result;
      setTimeout(() => {
        self.bloadding = false;
      }, 500);
    });
    this.init();
  },
  methods: {
    async init() {
      var { result } = await getIndexcount();
      this.downcount = parseInt(result.downcount);
      this.opencatalog = parseInt(result.opencatalog);
      this.datacount = parseInt(result.datacount);
      this.viewCount = parseInt(result.viewCount);
      this.facecount = parseInt(result.facecount);
      gsap.to(this.$data, { duration: 0.5, downcount: this.downcount });
      gsap.to(this.$data, { duration: 0.5, opencatalog: this.opencatalog });
      gsap.to(this.$data, { duration: 0.5, datacount: this.datacount });
      gsap.to(this.$data, { duration: 0.5, viewCount: this.viewCount });
      gsap.to(this.$data, { duration: 0.5, facecount: this.facecount });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>
<style lang="scss">
.index-container {
  display: flex;
  flex-direction: column;
  min-width: $base-main-width;
}
.category-container {
  .el-tabs__nav-wrap::after {
    background: #e8e8e8 !important;
    height: 2px;
  }
}

.index-banner {
  position: relative;
  height: 400px;
  .banner {
    height: 100%;
    width: 100%;
    img {
      height: 100%;
      width: 100%;
    }
  }
  img {
    height: 100%;
    width: 100%;
  }
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .banner-title {
    position: absolute;
    font-size: 78px;
    color: #ffffff;
    line-height: 79px;
    display: flex;
    letter-spacing: 5px;
    flex-direction: column;
    .sm-title {
      font-size: 42px;
      font-weight: 400;
      color: #ffffff;
      line-height: 33px;
      margin-top: 10px;
      letter-spacing: 3px;
    }
  }
  .data-info {
    position: absolute;
    display: flex;
    flex-direction: row;
    width: 1060px;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0 auto;
    z-index: 1000;
    justify-content: space-between;
    .info-item {
      height: 120px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .info-item-title {
        font-size: 32px;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
      }
      .sm-title {
        font-size: 32px;
        font-weight: 500;
        color: #ffce42;
        line-height: 40px;
        span {
          font-size: 22px;
          font-weight: 400;
          color: #ffffff;
          line-height: 25px;
        }
      }
    }
  }
}
.el-card__body {
  padding: 0 !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.info-container {
  .el-tabs__active-bar {
    background-color: transparent !important;
  }
  .el-tabs__header .el-tabs__nav-scroll .el-tabs__item {
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
    color: #333333;
    padding: 0;
  }
  .el-card__header {
    padding: 0;
  }
  .el-tabs__nav-scroll .el-tabs__nav {
    width: 450px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .el-tabs__header .el-tabs__nav-scroll .is-active {
    color: #1471dc;
    padding: 0 !important;
  }
}
.el-tabs__nav-scroll {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.el-tabs__nav-wrap::after {
  background: #e8e8e8 !important;
  height: 2px;
}
.category-container {
  .el-tabs__header .el-tabs__nav-scroll .el-tabs__item {
    line-height: 56px;
    text-align: center;
    width: 160px;
    height: 56px;
    border-radius: 4px;
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    padding: 0;
  }

  .el-tabs__header .el-tabs__nav-scroll .is-active {
    background: $base-theme-color;
    box-shadow: 0px 2px 10px 0px rgba(20, 113, 220, 0.4);
    color: #ffffff;
    padding: 0;
  }
}
</style>
